import { createAction, createPayloadAction } from '../../../core/helpers'

import {
  ADD_CUISINE_TYPE,
  EXPAND_CUISINE_TYPE_MAIN_TREE_KEYS,
  EXPAND_CUISINE_TYPE_SUPPORTING_TREE_KEYS,
  FETCH_CUISINE_TYPES,
  MOVE_CUISINE_TYPES,
  RENAME_CUISINE_TYPE,
  RESET_CUISINE_TYPE_TREE,
  SET_DATA_FOR_RENAMING_CUISINE_TYPE,
} from '../action-types'

export const cleanupFetchCuisineTypes = createAction(
  FETCH_CUISINE_TYPES.CLEANUP,
)

export const addCuisineTypeNode = createPayloadAction(ADD_CUISINE_TYPE)

export const renameCuisineTypeNode = createPayloadAction(RENAME_CUISINE_TYPE)
export const resetCuisineTypeTree = createAction(RESET_CUISINE_TYPE_TREE)
export const moveCuisineTypes = createPayloadAction(MOVE_CUISINE_TYPES)

export const setDataForRenamingCuisineType = createPayloadAction(
  SET_DATA_FOR_RENAMING_CUISINE_TYPE,
)

export const expandCuisineTypeMainTreeKeys = createPayloadAction(
  EXPAND_CUISINE_TYPE_MAIN_TREE_KEYS,
)

export const expandCuisineTypeSupportingTreeKeys = createPayloadAction(
  EXPAND_CUISINE_TYPE_SUPPORTING_TREE_KEYS,
)
